export const InvoiceModuleConditon = (organizationData) => {
  return organizationData?.organizationData?.organization_type?.slug ===
    "auctioneer"
    ? true
    : false;
};

export const LawyerConditon = (organizationData) => {
  return organizationData?.organizationData?.organization_type?.slug ===
    "lawyer"
    ? true
    : false;
};

export const AMLCTFModuleConditonIndustry = (organizationData) => {
  return organizationData?.organizationData?.organization_type?.slug ===
    "conveyancer" ||
    organizationData?.organizationData?.organization_type?.slug === "dealer" ||
    organizationData?.organizationData?.organization_type?.slug === "lawyer" ||
    organizationData?.organizationData?.organization_type?.slug ===
      "real-estate-agent"
    ? true
    : false;
};
